import React from "react";
import Hero from "../../components/services/interior/Hero";
import Services from "../../components/services/interior/Services";

import WhyChooseUs from "../../components/services/interior/Whychooseus";
import Experts from "../../components/services/interior/Experts";
import IdDetailed from "../../components/services/interior/IDDetailed";
import { Helmet } from "react-helmet-async";

function Interior() {
  return (
    <div>
      <Helmet>
        <title>
          Interior Design Services in Jodhpur | Home & Office Interior Design
        </title>

        <meta
          name="description"
          content="Professional interior design services in Jodhpur for homes, offices, commercial spaces and modular kitchens. Modern, functional and customized interior solutions."
        />

        <meta
          name="keywords"
          content="Interior Design Services Jodhpur, Home Interior Design, Office Interior Design, Modular Kitchen Design, Interior Designer Rajasthan"
        />

        <link rel="canonical" href="https://webxsecure.in/interior-designing" />

        <meta
          property="og:title"
          content="Interior Design Services in Jodhpur"
        />

        <meta
          property="og:description"
          content="Transform your home, office and commercial spaces with modern interior design solutions."
        />

        <meta
          property="og:url"
          content="https://webxsecure.in/interior-designing"
        />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:type" content="website" />

        {/* Service Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Interior Design Services",
            provider: {
              "@type": "Organization",
              name: "Web X Secure",
            },
            serviceType: "Interior Design",
            areaServed: "India",
            url: "https://webxsecure.in/interior-designing",
          })}
        </script>

        {/* Breadcrumb */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Interior Designing",
                item: "https://webxsecure.in/interior-designing",
              },
            ],
          })}
        </script>
      </Helmet>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Experts />
      <IdDetailed />
    </div>
  );
}

export default Interior;
